import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/email';

import { AdvancedSearchOrderContext } from '../../context';
import messages from './messages';

const EmailFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchOrderContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.email} updateFilter={updateFilter} />;
};

export default EmailFilter;
